var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail-wrap"},[_c('div',{directives:[{name:"viewer",rawName:"v-viewer",value:(_vm.options),expression:"options"}],staticClass:"img-box"},_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,attrs:{"src":item,"onerror":_vm.defaultImg}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42b17a8f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thumbnail.vue
// module id = null
// module chunks = 